module.exports = __webpack_public_path__ + "static/media/mysql.927b0e68.jpg";